import m, {Vnode} from "mithril";
import {LabelItem} from "../../../../model/items/labelItem";
import {Questionary} from "../../../../model/questionary";

export default class LabelCell {

    private readonly questionary: Questionary;

    constructor(
        public readonly label: LabelItem
    ) {
        this.questionary = label.cell.grid.questionary;
    }

    public view(): Vnode|null {

        if (!this.label.cell.visible) {
            return null;
        }

        const cssClass = 'labelCell' + (this.label.cell.cssClass ? (' '+this.label.cell.cssClass) : '');

        return m("div", {
            "class": cssClass,
        }, [
            m(
                "label",
                {for: this.label.labelFor},
                m.trust(this.questionary.renderText(this.label.childrenTags[0]?.value || ''))
            )
        ]);
    }
}